import React from "react";
import ImageGallery from "../components/ImageGallery";

function ExterieurPage() {
  return <ImageGallery category="exterieur" />;
}

export default ExterieurPage;
